import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles({
  bullet: {
    width: function width(_ref) {
      var _width = _ref.width;
      return _width;
    },
    height: function height(_ref2) {
      var _height = _ref2.height;
      return _height;
    },
    borderRadius: '50%'
  }
});

var Bullet = function Bullet(_ref3) {
  var height = _ref3.height,
      width = _ref3.width,
      color = _ref3.color,
      className = _ref3.className,
      style = _ref3.style;
  var classes = useStyles({
    width: width,
    height: height
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cn(classes.bullet, _defineProperty({}, "bg-".concat(color), color), className),
    style: style,
    "data-qa": "bullet"
  });
};

Bullet.defaultProps = {
  color: 'muted',
  width: 4,
  height: 4,
  className: '',
  style: {}
};
Bullet.propTypes = {
  /** Bullet color */
  color: PropTypes.string,

  /** Bullet height */
  height: PropTypes.number,

  /** Bullet width */
  width: PropTypes.number,

  /** Additional class for bullet root level */
  className: PropTypes.string,

  /** Additional style to bullet root level */
  style: PropTypes.shape()
};
export default Bullet;